import React from 'react';

export const ChevronRight = ({ color, ...rest }: { color?: string, [key: string]: unknown }): JSX.Element => {
  const className = 'icon icon--chevron-right';
  color = color || '#0076CC';

  return (
    <svg
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className, ...rest }}
    >
      <path
        d="M0.999999 1L8 8L1 15"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronRight;
